module.exports = __webpack_public_path__ + "img/avatar2.032d9c67.png";